import React from "react";
import PropTypes from "prop-types";
import { getPublicAssetUrl } from "utils/getPublicAssetUrl";
import "assets/styles.css";

// TODO: Replace with public/assets/icons/compare-team.svg when available.
// Currently using public/icons/team-comparison.svg as the compare icon.
const COMPARE_ICON_URL = getPublicAssetUrl("icons/team-comparison.svg");

function CompareIcon() {
  return (
    <img
      className="TDHeaderCompareButtonIcon"
      src={COMPARE_ICON_URL}
      alt=""
      aria-hidden="true"
    />
  );
}

export default function TeamCompareButton({ onClick, disabled }) {
  return (
    <button
      type="button"
      className="TDHeaderCompareButton"
      onClick={onClick}
      disabled={disabled}
      aria-label="Compare team"
    >
      <CompareIcon />
      <span className="TDHeaderCompareButtonText">Compare Team</span>
    </button>
  );
}

TeamCompareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TeamCompareButton.defaultProps = {
  disabled: false,
};
